module.exports = __webpack_public_path__ + "img/yasumasa.538877c8.jpg";